import React from "react";
import { Helmet } from "react-helmet";
import { apiPromiseHook } from "../../../shared/flux/actions/enterHooks";
import { connect } from "react-redux";
import { EnterHookPromises } from "../../state/enterHookPromises";
import { Loader } from './../../../core/atoms/loader';

interface ILtoTermsComponentProps extends React.Props<LtoTermsComponent> {
  lto: IState<ILto>;
  ltoTerms: IState<ILtoTerms>;
}

export class LtoTermsComponent extends React.Component<ILtoTermsComponentProps, {}> {
  render() {
    if (this.props.ltoTerms.status !== "OK" || this.props.lto.status !== "OK") {
      return <Loader/>;
    }

    return (
      <div className="width-wrapper lto-terms-conditions">
        <Helmet title={`${this.props.lto.data.name} - Terms & Conditions`} />
        <header>
          <h2 className="section">Terms and conditions</h2>
        </header>
        <article dangerouslySetInnerHTML={{ __html: this.props.ltoTerms.data.termsAndConditionsHtml }}/>        
      </div>
    );
  }
}

const mapStateToProps = (state: IWebStoreState) => {
  return {
    lto: state.lto,
    ltoTerms: state.ltoTerms
  }
}

export const LtoTerms = connect(
  mapStateToProps
)(LtoTermsComponent)

export const ltoTermsOnEnter = apiPromiseHook(EnterHookPromises.ltoTermsBySlug("ltoSlug") as any);
